/**
 * nordura-product-tabs.js
 * Tab switching for sections/product-info-tabs.liquid. Plain click delegation,
 * no dependency on the product-form controller so this section works even if
 * dropped onto a non-product page.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    document.querySelectorAll('[data-n-tabs-bar]').forEach(function (bar) {
      var section = bar.closest('.n-tabs');
      if (!section || section.dataset.nTabsBound) return;
      section.dataset.nTabsBound = 'true';

      bar.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-n-tab-btn]');
        if (!btn) return;
        var index = btn.dataset.nTabBtn;

        bar.querySelectorAll('[data-n-tab-btn]').forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        section.querySelectorAll('[data-n-tab-panel]').forEach(function (panel) {
          panel.classList.toggle('is-active', panel.dataset.nTabPanel === index);
        });
      });
    });

    // "Wähle ein Paket" style buttons anywhere on the page scroll to the buy box.
    document.querySelectorAll('[data-n-scroll-to-buy]').forEach(function (btn) {
      if (btn.dataset.nScrollBound) return;
      btn.dataset.nScrollBound = 'true';
      btn.addEventListener('click', function () {
        var target = document.getElementById('kaufen');
        if (!target) return;
        var top = target.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }
})();
